import { ReactNode } from 'react';
import { FlexProps, InputGroupProps } from '@chakra-ui/react';
import { t } from '@/i18n';

export enum DateFilterInputValue {
  ALL = '',
  SEVEN = 'SEVEN',
  FIFTEEN = 'FIFTEEN',
  THIRTY = 'THIRTY',
  NINETY = 'NINETY',
  DEFINE_DATE = 'DEFINE_DATE',
}

export interface DateRange {
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
}

export type DateRangeChangeHandler = (startDate: string, endDate: string) => void;

export interface DateRangeFilterFieldsProps {
  dateSelectLabel?: ReactNode;
  startDate?: string;
  endDate?: string;
  dateValue?: DateFilterInputValue;
  onDateValueChange?: (dateValue: DateFilterInputValue) => void;
  onRangeChange?: DateRangeChangeHandler;
  startDateRootProps?: InputGroupProps;
  endDateRootProps?: InputGroupProps;
  containerProps?: FlexProps;
}

export const transalateDateFilterInputValue = (value: string) => {
  switch (value) {
    case DateFilterInputValue.ALL:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_all');
    case DateFilterInputValue.SEVEN:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_seven_days');
    case DateFilterInputValue.FIFTEEN:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_fifteen_days');
    case DateFilterInputValue.THIRTY:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_thirty_days');
    case DateFilterInputValue.NINETY:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_ninety_days');
    case DateFilterInputValue.DEFINE_DATE:
      return t('components.date_range_filter_fields.date_range_filter_fields_option_define_date');
    default:
      return value;
  }
};

export interface DateRangeFilterFieldsProps {
  dateSelectLabel?: ReactNode;
  startDate?: string;
  endDate?: string;
  dateValue?: DateFilterInputValue;
  onDateValueChange?: (dateValue: DateFilterInputValue) => void;
  onRangeChange?: DateRangeChangeHandler;
  inputName?: string;
}
